import currency from "@/helpers/currency";

export const headersATS = {
  //
  execucao: [
    { text: "Grupo", value: "grupo" },
    { text: "Município", value: "municipio" },
    { text: "Iniciativa", value: "solucao" },
    { text: "Responsável", value: "responsavel" },
    { text: "Horas Previstas", value: "horasPrevistas" },
    {
      text: "Horas com Relatórios Aprovados",
      value: "horasRelatoriosAprovados",
    },
    { text: "Horas Agendadas", value: "horasAgendadas" },
    { text: "Total de Horas", value: "totalGeralHoras" },
    { text: "Saldo Disponível", value: "saldoDisponivel" },

    { text: "%", value: "percentualExecutado" },
  ],
  execucao_por_tarefas: [
    { text: "Grupo", value: "grupo" },
    { text: "Município", value: "municipio" },
    { text: "Iniciativa", value: "solucao" },
    { text: "Responsável", value: "responsavel" },
    { text: "Atividades Previstas", value: "horasPrevistas" },
    { text: "Atividades Executadas", value: "horasRealizadas" },
    { text: "%", value: "percentual" },
  ],
  relatorio_por_solucao: [
    { text: "Grupo", value: "grupo" },
    { text: "Iniciativa", value: "solucao" },
    { text: "Município", value: "municipio" },
    { text: "Data", value: "data" },
    { text: "Responsável", value: "responsavel" },
    { text: "Relatório", value: "relatorio" },
    { text: "Atividades", value: "Atividades" },
    { text: "Horas", value: "horas" },
    { text: "Situação", value: "situacao" },
  ],
  encontros_por_solucao: [
    { text: "Título", value: "titulo" },
    { text: "Responsável", value: "responsavel" },
    { text: "Município", value: "municipio" },
    { text: "Data", value: "data" },
    { text: "Tem Relatório", value: "relatorio" },
  ],
  situacaoVisitas: [
    { text: "Município", value: "municipio" },
    { text: "Iniciativa", value: "solucao" },
    { text: "Responsavel", value: "responsavel" },
    { text: "Status", value: "situacao" },
    { text: "Visitas", value: "visitas" },
  ],
  situacaoTarefa: [
    { text: "Município", value: "municipio" },
    { text: "Iniciativa", value: "solucao" },
    { text: "Responsavel", value: "responsavel" },
    { text: "Atividade", value: "tarefa", width: "30%" },
    { text: "Data", value: "dataEvento", align: "start" },
    { text: "Status", value: "situacao" },
  ],
  diagnostico: [
    { text: "Município", value: "municipio" },
    { text: "Eixo", value: "eixo" },
  ],
  diagnosticoFinalizado: [
    { text: "Município", value: "nomeMunicipio", align: "start" },
    { text: "Eixo", value: "nome", align: "start" },
    { text: "Pontos ", value: "pontos", align: "start" },
  ],
  evidencias: [
    { text: "Município", value: "municipio", align: "start" },
    { text: "Eixo", value: "eixo" },
    { text: "Questões não evidenciadas", value: "semEvidencias" },
  ],
  rejeicao: [
    { text: "Município", value: "municipio" },
    { text: "Eixo", value: "eixo" },
    { text: "Perguntas", value: "perguntas" },
    { text: "Respondidas", value: "respondidas" },
    { text: "Evidenciadas", value: "evidenciadas" },
    { text: "Aprovadas", value: "aprovadas" },
    { text: "Rejeitadas", value: "rejeitadas" },
    { text: "Aguardando Análise", value: "aguardandoAnalise" },
  ],
  execucao_hora: [
    { text: "Município", value: "municipio" },
    { text: "Horas Previstas", value: "horasPrevistas" },
    { text: "Horas Realizadas", value: "horasRealizadas" },
    { text: "Percentual", value: "percentual" },
    { text: "Responsável", value: "responsavel" },
    { text: "Iniciativa", value: "solucao" },
  ],
  situacao_medalha: [
    { text: "Município", value: "nome" },
    { text: "Tema", value: "nomeTema" },
    { text: "Medalha Bronze", value: "possuiBronze" },
    { text: "Medalha Prata", value: "possuiPrata" },
    { text: "Medalha Ouro", value: "possuiOuro" },
  ],
  situacao_medalha_pontos_tema: [
    { text: "Município", value: "nome" },
    { text: "Região", value: "nomeRegiao" },

    { text: "Tema", value: "nomeTema" },
    { text: "Pontos", value: "pontos" },
    { text: "Pontos de acompanhamento", value: "acompanhamentosPontos" },

    { text: "Medalha Bronze", value: "bronze" },
    { text: "Medalha Prata", value: "prata" },
    { text: "Medalha Ouro", value: "ouro" },
  ],
  execucao_tarefas_inicio_fim: [
    { text: "Município", value: "municipio" },

    { text: "Início", value: "inicio" },
    { text: "Fim", value: "fim" },
    { text: "Projeto", value: "projeto" },
    { text: "Percentual", value: "percentual" },
    { text: "Iniciativa", value: "solucao" },
    { text: "Atividades Previstas", value: "tarefasPrevistas" },
    { text: "Atividades Realizadas", value: "tarefasRealizadas" },
  ],
  eixo_municipio_desagrupado: [
    { text: "Município", value: "municipio" },
    { text: "Uf", value: "uf" },
    { text: "Codigo IBGE", value: "codigoIbge" },
    { text: "Relacionamento", value: "relacionamento" },
    { text: "Eixo", value: "eixo" },
    { text: "Eixos", value: "eixos" },
    { text: "Nome Projeto", value: "nomeProjeto" },
  ],
  eixo_municipio: [
    { text: "Município", value: "municipio" },
    { text: "Uf", value: "uf" },
    { text: "Codigo IBGE", value: "codigoIbge" },
    { text: "Relacionamento", value: "relacionamento" },
    { text: "Eixo", value: "eixo" },
    { text: "Eixos", value: "eixos" },
    { text: "Nome Projeto", value: "nomeProjeto" },
  ],
  relacao_solucao_tarefa_cadastrada_uf: [
    { text: "Grupo de Iniciativa", value: "municipio" },
    { text: "Iniciativa", value: "uf" },
    { text: "Descrição da Iniciativa", value: "codigoIBGE" },
    { text: "Atividade", value: "relacionamento" },
    { text: "Descrição da Atividade", value: "relacionamento" },
    { text: "Evidência", value: "relacionamento" },
  ],
  plano_acao_analitico: [
    { text: "Unidade Regional", value: "nomeRegiao" },
    { text: "Município", value: "nomeMunicipio" },
    { text: "Temas", value: "nomeTema" },
    { text: "Pergunta", value: "numero" },
    { text: "Pontos", value: "pontos" },
    { text: "Indicador", value: "indicador" },
    { text: "Resposta", value: "resposta" },
    { text: "Evidencia", value: "evidencia" },
  ],
  analitico_indicadores: [
    { text: "Unidade Regional", value: "nomeRegiao" },
    { text: "Município", value: "nomeMunicipio" },
    { text: "Temas", value: "nomeTema" },
    { text: "Pergunta", value: "numero" },
    { text: "Pontos", value: "pontos" },
    { text: "Indicador", value: "indicador" },
    { text: "Resposta", value: "resposta" },
    { text: "Data Resposta", value: "dataResposta" },
  ],
  consolidado_indicadores_sim: [
    { text: "Unidade Regional", value: "nomeMunicipio" },
    { text: "Município", value: "nomeRegiao" },
    { text: "Temas", value: "nomeTema" },
    { text: "Quantidade de Indicadores", value: "quantidadeIndicadores" },
    { text: "Respostas SIM", value: "respostaSim" },
  ],
  indicadores_ativos: [
    { text: "Temas", value: "nome" },
    { text: "Pergunta", value: "numero" },
    { text: "Pontos", value: "pontos" },
    { text: "Nacional", value: "nacional" },
    { text: "Indicador", value: "texto" },
    { text: "Evidencia", value: "evidencia" },
  ],
  to_pendentes: [
    { text: "Uf", value: "uf" },
    { text: "Codigo IBGE", value: "codigoIBGE" },
    { text: "Município", value: "nomeMunicipio" },
    { text: "Tema", value: "nomeTema" },
    { text: "Unidade Regional", value: "nomeRegiao" },
    { text: "T0", value: "nomeregiao" },
  ],
  municipio_quantidade_mensuracoes: [
    { text: "Unidade Regional", value: "unidadeRegional" },
    { text: "Projeto", value: "projeto" },
    { text: "Município", value: "municipio" },
    { text: "Eixo", value: "eixo" },
    { text: "Mensurações", value: "mensuracoes" },
  ],
  municipio_quantidade_mensuracoes_regional_municipio: [
    { text: "Unidade Regional", value: "nomeRegiao" },
    { text: "Município", value: "municipio" },
    { text: "Eixo", value: "eixos" },
    { text: "Mensurações", value: "mensuracoes" },
  ],
  municipio_eixo_status_relacionamento: [
    { text: "Uf", value: "uf" },
    { text: "Codigo IBGE", value: "codigoIbge" },
    { text: "Município", value: "nome" },
    { text: "Status", value: "statusNome" },
    { text: "Eixo", value: "eixoNome" },
    { text: "Relação com CE", value: "relacaoCe" },
  ],
  evidencia_rejeitada_por_municipio: [
    { text: "Nome Região", value: "nomeRegiao", width: "5%" },
    { text: "Município", value: "municipio", width: "10%" },
    { text: "Resposta", value: "resposta", width: "10%" },
    { text: "Situacao da evidência", value: "situacaoEvidencia", width: "10%" },
    { text: "Justificativa", value: "justificativa", width: "15%" },
    { text: "Arquivo", value: "link", width: "5%" },
    { text: "Arquivos Inseridos", value: "arquivosInseridos", width: "10px" },
    { text: "Tema", value: "tema", width: "10%" },
    { text: "N° Pergunta", value: "numero", width: "10%" },
    { text: "Indicador", value: "indicador", width: "10%" },
    { text: "Pontos", value: "pontos", width: "5%" },
  ],
  relacao_diagnosticos: [
    { text: "Unidade Regional", value: "unidadeRegional", width: "5%" },
    { text: "Município", value: "municipio", width: "10%" },
    { text: "Usuário", value: "usuario", width: "10%" },
    {
      text: "Diagnóstico / Acompanhamento",
      value: "diagnosticoAcompamhamento",
      width: "10%",
    },
    { text: "Data", value: "data", width: "15%" },
    {
      text: "Indicadores Positivados",
      value: "indicadoresPositivados",
      width: "15%",
    },
  ],
  parceiro_selos_atribuidos: [
    { text: "Nome", value: "nome" },
    { text: "Selo", value: "selo" },
  ],
  quantidade_selos_atribuidos: [
    { text: "Ouro", value: "ouro" },
    { text: "Prata", value: "prata" },
    { text: "Bronze", value: "bronze" },
  ],
  diagnosticos_consolidados_situacao: [
    { text: "UF", value: "uf", align: "start" },
    { text: "Não Iniciado", value: "naoIniciado" },
    { text: "Em Preenchimento", value: "emPreenchimento" },
    { text: "Enviado", value: "enviado" },
  ],
  diagnosticos_detalhados: [
    { text: "UF", value: "uf", align: "start" },
    { text: "Unidade Regional", value: "nomeRegiao" },
    { text: "Sala", value: "nome" },
    { text: "Situação", value: "situacao" },
  ],
  diagnosticos_admin_periodo: [
    { text: "Consultor", value: "usuarioNome", align: "start" },
    { text: "Município", value: "municipioNome" },
    { text: "Início", value: "inicio" },
    { text: "Fim", value: "fim" },
    { text: "Horas", value: "horas" },
    { text: "Status", value: "status" },
  ],
  situacao_detalhada_envio_evidencia: [
    { text: "Regional", value: "nomeRegiao", align: "start" },
    { text: "Sala", value: "municipioNome", align: "start" },
    { text: "Pilar", value: "nomeTema", align: "start" },
    { text: "Critério", value: "texto", align: "start" },
    {
      text: "Arquivos não Enviados",
      value: "naoEnviadosAnalise",
      align: "start",
    },
    {
      text: "Arquivos Enviados",
      value: "arquivosEnviadosAnalise",
      align: "start",
    },
    { text: "Arquivos em Análise", value: "arquivosEmAnalise", align: "start" },
    { text: "Arquivos Aprovados", value: "arquivosAprovados", align: "start" },
    {
      text: "Arquivos Rejeitados",
      value: "arquivosRejeitados",
      align: "start",
    },
    { text: "Pontos Possíveis", value: "pontosPossiveis", align: "start" },
    { text: "Pontos Obtidos", value: "pontosObtidos", align: "start" },
  ],
  analitico_pontos_eixos: [
    { text: "Eixo", value: "eixo", align: "start" },
    { text: "Município", value: "municipio", align: "start" },
    { text: "Pontos", value: "pontos", align: "start" },
    { text: "Projeto", value: "projeto", align: "start" },
    { text: "UF", value: "uf", align: "start" },
    { text: "Usuário", value: "usuario", align: "start" },
  ],
  quantitativo_municipio_sem_atuacao_regiao: [
    { text: "Regional", value: "regional", align: "start" },
    { text: "Com atuação", value: "comAtuacao", align: "start" },
    { text: "Sem atuação", value: "semAtuacao", align: "start" },
  ],
  encontros_realizados_status: [
    { text: "Regional", value: "regional", align: "start" },
    { text: "Município", value: "nome", align: "start" },
    { text: "Com Relatório", value: "comRelatorio", align: "start" },
    { text: "Sem Relatório", value: "semRelatorio", align: "start" },
  ],
  municipios_status_atuacao_responsavel: [
    { text: "Regional", value: "regional", align: "start" },
    { text: "Município", value: "municipio", align: "start" },
    { text: "Atuação", value: "atuacao", align: "start" },
    { text: "Responsável", value: "responsavel", align: "start" },
  ],

  cliente_oculto_analitico_situacao: [
    { text: "Uf", value: "uf", align: "start" },
    { text: "Código Ibge", value: "codigoIbge", align: "start" },
    { text: "Município", value: "nome", align: "start" },
    { text: "Status", value: "status", align: "start" },
    { text: "Arquivos Enviados", value: "arquivosEnviados", align: "start" },
  ],
  execucao_cliente_oculto: [
    { text: "UF", value: "uf", align: "start" },
    { text: "Sala/Parceiro", value: "nome", align: "start" },
    { text: "Critério", value: "grupoNome", align: "start" },
    { text: "Situação", value: "situacao", align: "start" },
    { text: "Última atualização", value: "ultimaAtualizacao", align: "start" },
    { text: "Atualizado por", value: "atualizadoPor", align: "start" },
  ],
  mensuracao_detalhada_por_periodo: [
    { text: "Município", value: "municipio", align: "start" },
    { text: "Acompanhamento", value: "nome", align: "start" },
    { text: "Responsável", value: "responsavel", align: "start" },
    { text: "Data de Finalização", value: "dataFinalizacao", align: "start" },
    { text: "Eixo", value: "eixo", align: "start" },
    { text: "Indicador", value: "indicador", align: "start" },
    { text: "Resposta", value: "resposta", align: "start" },
  ],
  situacao_solucoes_municipios: [
    { text: "Município", value: "municipio", align: "start" },
    { text: "Grupo", value: "grupo", align: "start" },
    { text: "Iniciativa", value: "solucao", align: "start" },
    {
      text: "Situação da Iniciativa",
      value: "situacaoSolucao",
      align: "start",
    },
    { text: "Atividade", value: "tarefa", align: "start" },
    { text: "Horas", value: "horas", align: "start" },
    { text: "Situação da Atividade", value: "situacaoTarefa", align: "start" },
    { text: "Evidência", value: "evidencia", align: "start" },
  ],
  prateleira_de_solucoes: [
    { text: "Grupo", value: "grupo", align: "start" },
    { text: "Iniciativa", value: "solucao", align: "start" },
    { text: "Atividade", value: "tarefa", align: "start" },
    { text: "Horas", value: "horas", align: "start" },
  ],
  territorios_iniciativas: [
    { text: "Uf", value: "uf", align: "start" },
    { text: "Território", value: "nomeTerritorio", align: "start" },
    { text: "Link", value: "link", align: "start" },
    { text: "Nome Fantasia", value: "nomeFantasia", align: "start" },
    { text: "Inicio", value: "inicio", align: "start" },
    { text: "Status", value: "statusTerritorio", align: "start" },
    { text: "Iniciativa", value: "iniciativa", align: "start" },
    {
      text: "Categoria da Iniciativa",
      value: "categoriaIniciativa",
      align: "start",
    },
    {
      text: "Descrição da Iniciativa",
      value: "descricaoIniciativa",
      align: "start",
    },
    { text: "Iniciativa Própria", value: "iniciativaPropria", align: "start" },
    { text: "Todos os municípios", value: "emTodosMunicipios", align: "start" },
    { text: "Municípios Implementados", value: "excecao", align: "start" },
    { text: "Início da iniciativa", value: "inicioIniciativa", align: "start" },
    { text: "Fim da iniciativa", value: "fimIniciativa", align: "start" },
    { text: "Status da iniciativa", value: "statusIniciativa", align: "start" },
    { text: "Custo da iniciativa", value: "custo", align: "start" },
    {
      text: "Responsáveis da iniciativa",
      value: "responsaveis",
      align: "start",
    },
    { text: "Atores da iniciativa", value: "atores", align: "start" },
    { text: "Envolve prefeitura?", value: "envolvePrefeitura", align: "start" },
  ],
  territorios_municipios: [
    { text: "UF", value: "uf", align: "start" },
    { text: "Código IBGE", value: "codigoIbge", align: "start" },
    { text: "Município", value: "municipio", align: "start" },
    { text: "Território", value: "nomeTerritorio", align: "start" },
    { text: "Nome Fantasia", value: "nomeFantasia", align: "start" },

    { text: "Inicio", value: "inicio", align: "start" },
    { text: "Status", value: "statusTerritorio", align: "start" },
    { text: "Responsáveis", value: "responsaveis", align: "start" },
    { text: "Categorias", value: "categorias", align: "start" },
    { text: "Iniciativas", value: "iniciativas", align: "start" },
  ],
  selo: [
    { text: "UF", value: "uf", align: "start" },
    { text: "Município", value: "municipioNome", align: "start" },
    { text: "Selo", value: "selo", align: "start" },
    { text: "Unidade Regional", value: "nomeRegiao", align: "start" },
  ],
  detalhamento_propostas: [
    { text: "Município", value: "nome", align: "start" },
    { text: "Status", value: "status", align: "start" },
    { text: "Valor Total", value: "valorTotal", align: "start" },
    {
      text: "Investimento Município",
      value: "investimentoMunicipio",
      align: "start",
    },
    { text: "Parcelas", value: "qtParcelas", align: "start" },
    { text: "Criação", value: "criacao", align: "start" },

    { text: "Data Criação", value: "dataCriacao", align: "start" },
    { text: "Análise", value: "analise", align: "start" },

    { text: "Data Análise", value: "dataAnalise", align: "start" },
    {
      text: "Autorização de Execução'",
      value: "autorizacaoExecucao",
      align: "start",
    },

    {
      text: "Data de início da execução",
      value: "dataInicioExecucao",
      align: "start",
    },
    { text: "Representantes", value: "representantes", align: "start" },
  ],
  status_propostas_analitico: [
    { text: "Número", value: "numero", align: "start" },
    { text: "Região", value: "nomeRegiao", align: "start" },
    { text: "Município", value: "nome", align: "start" },
    { text: "Status", value: "status", align: "start" },
    { text: "valor Total", value: "valorTotal", align: "start" },
    {
      text: "Investimento Município",
      value: "investimentoMunicipio",
      align: "start",
    },
    {
      text: "Contrapartida Sebrae",
      value: "contrapartidaSebrae",
      align: "start",
    },
    { text: "Qtd Parcelas", value: "qtdParcelas", align: "start" },
    { text: "Data Criação", value: "dataCriacao", align: "start" },
    { text: "Análise", value: "analise", align: "start" },
    { text: "Data da Análise", value: "dataAnalise", align: "start" },
    {
      text: "Autorização de Execução",
      value: "autorizacaoExecucao",
      align: "start",
    },
    {
      text: "Data de início da execução",
      value: "dataInicioExecucao",
      align: "start",
    },
    { text: "Representantes", value: "representantes", align: "start" },
    {
      text: "Eixos com Premium ou Extras",
      value: "eixosPremiumExtra",
      align: "start",
    },
    { text: "Premium", value: "premium", align: "start" },
    { text: "Extras", value: "extras", align: "start" },
  ],
  status_propostas_detalhado: [
    { text: "Número", value: "numero", align: "start" },
    { text: "Região", value: "nomeRegiao", align: "start" },
    { text: "Município", value: "nome", align: "start" },
    { text: "Status", value: "status", align: "start" },
    { text: "valor Total", value: "valorTotal", align: "start" },
    {
      text: "Investimento Município",
      value: "investimentoMunicipio",
      align: "start",
    },
    {
      text: "Contrapartida Sebrae",
      value: "contrapartidaSebrae",
      align: "start",
    },
    { text: "Qtd Parcelas", value: "qtdParcelas", align: "start" },
    { text: "Criação", value: "cricao", align: "start" },
    { text: "Data Criação", value: "dataCriacao", align: "start" },
    { text: "Análise", value: "analise", align: "start" },
    { text: "Data da Análise", value: "dataAnalise", align: "start" },
    {
      text: "Autorização de Execução",
      value: "autorizacaoExecucao",
      align: "start",
    },
    {
      text: "Data de início da execução",
      value: "dataInicioExecucao",
      align: "start",
    },
    { text: "Representantes", value: "representantes", align: "start" },
    {
      text: "Eixos com Premium ou Extras",
      value: "eixosPremiumExtra",
      align: "start",
    },
    { text: "Premium", value: "premium", align: "start" },
    { text: "Extras", value: "extras", align: "start" },
  ],
  propostas_valores_detalhados: [
    { text: "Número", value: "numero", align: "start" },
    { text: "Região", value: "nomeREgiao", align: "start" },
    { text: "Município", value: "nome", align: "start" },
    { text: "Status", value: "status", align: "start" },
    { text: "valor Total", value: "valorTotal", align: "start" },
    {
      text: "Investimento Município",
      value: "investimentoMunicipio",
      align: "start",
    },
    {
      text: "Contrapartida Sebrae",
      value: "contrapartidaSebrae",
      align: "start",
    },
    {
      text: "Essencial Sebrae",
      value: "essencialSebrae",
      align: "start",
    },
    {
      text: "Essencial Munícipio",
      value: "essencialMunicipio",
      align: "start",
    },
    {
      text: "Premium Sebrae",
      value: "premiumSebrae",
      align: "start",
    },
    {
      text: "Premium Munícipio",
      value: "premiumMunicipio",
      align: "start",
    },
    {
      text: "Extra Sebrae",
      value: "extraSebrae",
      align: "start",
    },
    {
      text: "Extra Município",
      value: "extraMunicipio",
      align: "start",
    },
  ],
  falta_evidenciar_municipio_eixo: [
    { text: "Regional", value: "unidadeRegional", align: "start" },
    { text: "Município", value: "municipio", align: "start" },
    { text: "Eixo", value: "eixo", align: "start" },
    { text: "Indicador", value: "indicador", align: "start" },
    { text: "Evidência(s)", value: "evidencia", align: "start" },
  ],
  historico_analise_evidencia: [
    { text: "Regional", value: "unidadeRegional", align: "start" },
    { text: "Município", value: "municipio", align: "start" },
    { text: "Eixo", value: "eixo", align: "start" },
    { text: "Indicador", value: "indicador", align: "start" },
    { text: "Analisada", value: "analisada", align: "start" },

    { text: "Aprovada", value: "aprovada", align: "start" },
    { text: "Rejeitada", value: "rejeitada", align: "start" },

    { text: "Evidência(s)", value: "evidencias", align: "start" },
    {
      text: "Justificativa da rejeição",
      value: "justificativaRejeicao",
      align: "start",
    },
    { text: "Nome do arquivo", value: "nomeArquivo", align: "start" },
    { text: "Evidênciado por", value: "evidenciadoPor", align: "start" },
    { text: "Evidênciado em", value: "evidenciadoEm", align: "start" },
    { text: "Avaliado por", value: "avaliadoPor", align: "start" },
    { text: "Avaliado em", value: "avaliadoEm", align: "start" },
  ],
  acompanhamento_indicador_detalhado: [
    { text: "Regional", value: "regional", align: "start" },
    { text: "Município", value: "municipio", align: "start" },
    { text: "Acompanhamento", value: "nomeAcompanhamento", align: "start" },
    { text: "Eixo", value: "eixo", align: "start" },
    { text: "Indicador", value: "indicador", align: "start" },
    { text: "Resposta", value: "resposta", align: "start" },
    { text: "Data Finalização", value: "dataFinalizacao", align: "start" },
    { text: "Responsável", value: "responsavel", align: "start" },
  ],
  acompanhamento_indicador_consolidado: [
    { text: "Regional", value: "regional", align: "start" },
    { text: "Município", value: "municipio", align: "start" },
    { text: "Acompanhamento", value: "nomeAcompanhamento", align: "start" },
    { text: "Eixo", value: "eixo", align: "start" },
    { text: "Sim", value: "sim", align: "start" },
    { text: "Não", value: "nao", align: "start" },
    { text: "Data Finalização", value: "dataFinalizacao", align: "start" },
    { text: "Responsável", value: "responsavel", align: "start" },
  ],
  pontuacao_evidencias_aprovadas: [
    { text: "Regional", value: "regional", align: "start" },
    { text: "Município", value: "municipio", align: "start" },
    { text: "Eixo", value: "eixo", align: "start" },
    { text: "No.", value: "numero", align: "start" },
    { text: "Indicador", value: "indicador", align: "start" },

    { text: "Responsável", value: "responsavel", align: "start" },
    { text: "Evidenciada", value: "evidenciada", align: "start" },
    { text: "Aprovada", value: "aprovada", align: "start" },
    { text: "Pontos Obtidos", value: "pontosObtidos", align: "start" },
    { text: "Nacional?", value: "nacional", align: "start" },
  ],
  nivel_maturidade: [
    { text: "Regional", value: "regional", align: "start" },
    { text: "Município", value: "municipios", align: "start" },
    { text: "Eixo", value: "eixo", align: "start" },
    { text: "Nível", value: "nivel", align: "start" },
    { text: "Pontos Obtidos", value: "pontosObtidos", align: "start" },
    { text: "Pontos Possíveis", value: "pontosPossiveis", align: "start" },
  ],
  situacao_atual_parcelas: [
    { text: "UF", value: "uf", align: "start" },
    { text: "Regional", value: "regional", align: "start" },
    { text: "Município", value: "municipio", align: "start" },
    { text: "Proposta", value: "proposta", align: "start" },
    { text: "Parcela", value: "parcela", align: "start" },
    { text: "Valor", value: "valor", align: "start" },
    { text: "Vencimento", value: "vencimento", align: "start" },
    { text: "Status", value: "status", align: "start" },
    { text: "Anexo", value: "anexo", align: "start" },
    { text: "Descrição do Anexo", value: "descricaoAnexo", align: "start" },
  ],
  evidencias_analisadas_empresa: [
    { text: "UF", value: "uf", align: "start" },
    { text: "Município", value: "salaParceiro", align: "start" },
    { text: "Indicador", value: "criterio", align: "start" },
    { text: "Situação", value: "situacao", align: "start" },
  ],
  execucao_por_contrato: [
    { text: "Unidade Regional", value: "nomeRegiao" },
    { text: "Código IBGE", value: "codigoIbge" },
    { text: "Município", value: "municipio" },
    { text: "Grupo de Solução", value: "grupoSolucao" },
    { text: "Solução", value: "solucao" },
    { text: "Responsável", value: "responsavel" },
    { text: "Número do Contrato", value: "numeroContrato" },
    { text: "Valor Previsto", value: "valorPrevisto", valueFormat: currency },
    { text: "Valor Hora", value: "valorHora", valueFormat: currency },
    { text: "Horas Previstas", value: "horasPrevistas" },
    { text: "Horas Executadas", value: "horasExecutadas" },
    { text: "Encontros Agendados", value: "encontrosAgendados" },
    { text: "Entregas Registradas", value: "entregasRegistradas" },
  ],
  saldo_contratos: [
    { text: "ID do Contrato", value: "contratoId", align: "start" },
    { text: "Responsável", value: "responsavel", align: "start" },
    { text: "Início", value: "inicio", align: "start" },
    { text: "Fim", value: "fim", align: "start" },
    { text: "Número do Contrato", value: "numeroContrato", align: "start" },
    { text: "Status", value: "status", align: "start" },
    { text: "Entregas Previstas", value: "entregasPrevistas", align: "start" },
    { text: "Entregas realizadas", value: "entregasRealizadas", align: "start" },
    {
      text: "Média de horas por entrega",
      value: "mediaHorasPorEntrega",
      align: "start",
    },
    { text: "Horas Previstas", value: "horasPrevistas", align: "start" },
    { text: "Valor Previsto", value: "valorPrevisto", align: "start" },
    { text: "Horas Executadas", value: "horasExecutadas", align: "start" },
    { text: "Valor Executado", value: "valorExecutado", align: "start" },
    { text: "Saldo de Horas", value: "saldoHoras", align: "start" },
    { text: "Desvio de Desempenho", value: "desvioDesempenho", align: "start" },
  ],
  ian_consolidado: [
    { text: "Município ID", value: "municipioId", align: "start" },
    { text: "UF", value: "uf", align: "start" },
    {
      text: "ID Unidade Regional",
      value: "unidadeRegionalId",
      align: "start",
    },
    {
      text: "Unidade Regional",
      value: "unidadeRegional",
      align: "start",
    },
    { text: "Código IBGE", value: "codigoIbge", align: "start" },
    { text: "Município", value: "municipio", align: "start" },
    { text: "Eixos 2025", value: "eixos2025", align: "start" },
    { text: "Eixos 2025 - Lista", value: "eixos2025Lista", align: "start" },
    { text: "Eixos 2026", value: "eixos2026", align: "start" },
    { text: "Eixos 2026 - Lista", value: "eixos2026Lista", align: "start" },
    {
      text: "Eixos Únicos no Ciclo",
      value: "eixosUnicosCiclo",
      align: "start",
    },
    {
      text: "Eixos únicos no Ciclo - Lista",
      value: "eixosUnicosCicloLista",
      align: "start",
    },
    { text: "Elegível IAN", value: "elegivelIan", align: "start" },
    {
      text: "Considerado para Cálculo do IAN",
      value: "consideradoCalculoIan",
      align: "start",
    },
    {
      text: "Motivo do Cálculo IAN",
      value: "ianMotivoCalculo",
      align: "start",
    },
    {
      text: "Ordem no Cálculo IAN",
      value: "ianOrdemCalculo",
      align: "start",
    },
    {
      text: "Temas Mensurados IAN",
      value: "ianTemasMensurados",
      align: "start",
    },
    {
      text: "Faixa Amostral IAN (%)",
      value: "ianFaixaAmostralPercentual",
      align: "start",
    },
    {
      text: "Mínimo da Amostra IAN",
      value: "ianMinimoMunicipiosAmostra",
      align: "start",
    },
    {
      text: "Elegíveis IAN na UF",
      value: "ianTotalMunicipiosElegiveisUf",
      align: "start",
    },
    {
      text: "Considerados IAN na UF",
      value: "ianTotalMunicipiosConsideradosUf",
      align: "start",
    },
    { text: "Status ID", value: "statusId", align: "start" },
    {
      text: "Status de Relacionamento",
      value: "statusRelacionamento",
      align: "start",
    },
    { text: "IAN Município", value: "ianMunicipio", align: "start" },
    { text: "IAN Regional", value: "ianRegional", align: "start" },
    { text: "IAN UF", value: "ianUf", align: "start" },
    { text: "Meta UF", value: "metaUf", align: "start" },
    { text: "IAN atualizado em", value: "ianAtualizadoEm", align: "start" },
    {
      text: "Consta em território ativo",
      value: "territorio",
      align: "start",
    },
    {
      text: "QTD de Iniciativas do Território",
      value: "qtdIniciativasTerritorio",
      align: "start",
    },
    { text: "IAN Território", value: "ianTerritorio", align: "start" },
    {
      text: "% Gestão e Políticas Públicas",
      value: "percentualGestaoPoliticasPublicas",
      align: "start",
    },
    {
      text: "% Lideranças Locais e Governança",
      value: "percentualLiderancasLocaisGovernanca",
      align: "start",
    },
    { text: "% Simplificação", value: "percentualSimplificacao", align: "start" },
    {
      text: "% Sala do Empreendedor",
      value: "percentualSalaEmpreendedor",
      align: "start",
    },
    {
      text: "% Compras Públicas",
      value: "percentualComprasPublicas",
      align: "start",
    },
    {
      text: "% Empreendedorismo na Escola",
      value: "percentualEmpreendedorismoEscola",
      align: "start",
    },
    {
      text: "% Inclusão Socioprodutiva",
      value: "percentualInclusaoSocioprodutiva",
      align: "start",
    },
    {
      text: "% Identidade, Vocações e Mercado",
      value: "percentualIdentidadeVocacoesMercado",
      align: "start",
    },
    {
      text: "% Resiliência Climática e Sustentabilidade",
      value: "percentualResilienciaClimaticaSustentabilidade",
      align: "start",
    },
    { text: "% Inovação", value: "percentualInovacao", align: "start" },
    {
      text: "% Acesso a Crédito",
      value: "percentualAcessoCredito",
      align: "start",
    },
    {
      text: "Gestão e Políticas Públicas - Última Mensuração",
      value: "gestaoPoliticasPublicasUltimaMensuracao",
      align: "start",
    },
    {
      text: "Lideranças Locais e Governança - Última Mensuração",
      value: "liderancasLocaisGovernancaUltimaMensuracao",
      align: "start",
    },
    {
      text: "Simplificação - Última Mensuração",
      value: "simplificacaoUltimaMensuracao",
      align: "start",
    },
    {
      text: "Sala do Empreendedor - Última Mensuração",
      value: "salaEmpreendedorUltimaMensuracao",
      align: "start",
    },
    {
      text: "Compras Públicas - Última Mensuração",
      value: "comprasPublicasUltimaMensuracao",
      align: "start",
    },
    {
      text: "Empreendedorismo na Escola - Última Mensuração",
      value: "empreendedorismoEscolaUltimaMensuracao",
      align: "start",
    },
    {
      text: "Inclusão Socioprodutiva - Última Mensuração",
      value: "inclusaoSocioprodutivaUltimaMensuracao",
      align: "start",
    },
    {
      text: "Identidade, Vocações e Mercado - Última Mensuração",
      value: "identidadeVocacoesMercadoUltimaMensuracao",
      align: "start",
    },
    {
      text: "Resiliência Climática e Sustentabilidade - Última Mensuração",
      value: "resilienciaClimaticaSustentabilidadeUltimaMensuracao",
      align: "start",
    },
    {
      text: "Inovação - Última Mensuração",
      value: "inovacaoUltimaMensuracao",
      align: "start",
    },
    {
      text: "Acesso a Crédito - Última Mensuração",
      value: "acessoCreditoUltimaMensuracao",
      align: "start",
    },
  ],
  ian_memoria_calculo: [
    { text: "UF", value: "uf", align: "start" },
    { text: "IAN UF", value: "ianUf", align: "start" },
    {
      text: "Elegíveis IAN na UF",
      value: "totalMunicipiosElegiveisUf",
      align: "start",
    },
    {
      text: "Faixa Amostral IAN (%)",
      value: "faixaAmostralPercentual",
      align: "start",
    },
    {
      text: "Mínimo da Amostra IAN",
      value: "minimoMunicipiosAmostra",
      align: "start",
    },
    {
      text: "Considerados IAN na UF",
      value: "totalMunicipiosConsideradosUf",
      align: "start",
    },
    { text: "IAN atualizado em", value: "ianAtualizadoEm", align: "start" },
    { text: "Município ID", value: "municipioId", align: "start" },
    { text: "Código IBGE", value: "codigoIbge", align: "start" },
    { text: "Município", value: "municipio", align: "start" },
    { text: "Unidade Regional", value: "unidadeRegional", align: "start" },
    { text: "Elegível IAN", value: "elegivelIan", align: "start" },
    {
      text: "Considerado para Cálculo do IAN",
      value: "consideradoCalculoIan",
      align: "start",
    },
    {
      text: "Ordem no Cálculo IAN",
      value: "ordemCalculoIan",
      align: "start",
    },
    {
      text: "Temas Mensurados IAN",
      value: "temasMensuradosIan",
      align: "start",
    },
    {
      text: "Situação da Mensuração IAN",
      value: "situacaoMensuracaoIan",
      align: "start",
    },
    { text: "IAN Município", value: "ianMunicipio", align: "start" },
    {
      text: "Motivo do Cálculo IAN",
      value: "motivoCalculoIan",
      align: "start",
    },
  ],
  recursos_dashboard: [
    { text: "ID do Recurso", value: "seloRecursoId" },
    { text: "Município", value: "municipioNome" },
    { text: "Sala", value: "salaNome" },
    { text: "Unidade Regional", value: "unidadeRegionalNome" },
    { text: "UF", value: "uf" },
    { text: "Solicitante", value: "solicitanteNome" },
    { text: "E-mail do solicitante", value: "solicitanteEmail" },
    { text: "Critério", value: "criterioTitulo" },
    { text: "Status", value: "statusLabel" },
    { text: "Nota Original", value: "notaOriginal" },
    { text: "Nota Pleiteada", value: "notaPleiteada" },
    { text: "Nota Homologada", value: "notaHomologada" },
    { text: "Data de Criação", value: "dataCriacao" },
    { text: "Data de Envio", value: "dataEnvio" },
    { text: "Data de Conclusão", value: "dataConclusao" },
    {
      text: "Tempo de Resposta (horas uteis)",
      value: "tempoRespostaHorasUteis",
    },
    { text: "Tempo aguardando (dias)", value: "tempoAguardandoDias" },
    { text: "Tempo em rascunho (dias)", value: "tempoCriacaoAteAgoraDias" },
    { text: "Parecer Final", value: "parecerFinal" },
    { text: "Justificativa", value: "justificativa" },
  ],
};
